module.exports = __webpack_public_path__ + "img/mylittletraderbot.24084423.jpg";